import gsap from "gsap/all";
/**
 * For Homepage Hero image slider
 */


const hp_hero_image_slider = document.querySelector( ".hp-hero .img-slider" );
if ( hp_hero_image_slider ) {
  console.log( hp_hero_image_slider );
  const slider = tns( {
    container: hp_hero_image_slider,
    items: 1,
    autoplay: true,
    loop: true,
    duration: 1500,
    speed: 1250,
    fixedHeight: 625,
    autoplayButtonOutput: false,
    controls: false,
  } );
}

if ( hp_hero_image_slider && 1 > 2 ) {
  let currentIndex = 0;
  // const images =
  const img = hp_hero_image_slider.querySelector( 'img' );
  console.log( hp_hero_images );
  function animateToNextImage () {
    if ( !img || hp_hero_images.length <= 1 ) return;

    // Move to next image index
    currentIndex = ( currentIndex + 1 ) % hp_hero_images.length;

    const tl = gsap.timeline();

    // Slide current image off screen to the left
    tl.to( img, {
      x: "-50vw",
      duration: 0.5,
      ease: "power2.inOut"
    } )
      // Swap the image source
      .call( () => {
        img.src = hp_hero_images[ currentIndex ];
      } )
      // Reset position off screen to the right
      .set( img, {
        x: "50vw",
        duration: 0
      } )
      // Slide new image back on screen from the right
      .to( img, {
        x: "0vw",
        duration: 0.5,
        ease: "power2.inOut"
      } );
  }
  setInterval( animateToNextImage, 3000 );
}

/**
 * For pages with hero banenr image slider
 */
const heroSlider = document.querySelector( ".hero .slider-images" );
if ( heroSlider ) {
  console.log( hero_slider_imgs );
  if ( hero_slider_imgs.length > 0 ) {
    let index = 0;
    const img = heroSlider.querySelector( 'img' );

    // Set initial image
    if ( img && hero_slider_imgs[ 0 ] ) {
      img.src = hero_slider_imgs[ 0 ];
    }

    const animateToNextImage = () => {
      if ( !img || hero_slider_imgs.length <= 1 ) return;

      // Move to next image index
      index = ( index + 1 ) % hero_slider_imgs.length;

      const tl = gsap.timeline();

      // Slide image off screen to the right
      tl.to( img, {
        x: "50vw",
        duration: 0.5,
        ease: "power2.inOut"
      } )
        // Swap the image source
        .call( () => {
          img.src = hero_slider_imgs[ index ];
        } )
        // Reset position off screen to the right
        // .set(img, {
        //     x: "100%"
        // })
        // Slide image back on screen from the right
        .to( img, {
          x: "0vw",
          duration: 0.5,
          ease: "power2.inOut"
        } );
    };

    // Start the animation loop
    const startSlider = () => {
      if ( hero_slider_imgs.length > 1 ) {
        setInterval( animateToNextImage, 6500 ); // Change image every 3 seconds
      }
    };

    // Start after a delay
    setTimeout( startSlider, 500 );
  }
}
